
// Set up the main page wrapper and its maxWith and height
export const usePageWrapper=(wrapperWidth, wrapperHeight, screenSize)=> {
  if(wrapperWidth > screenSize.width){
    wrapperWidth = screenSize.width;
  }
  let wrapperStyle = {
    width: wrapperWidth,
    height: wrapperHeight,
    overflow: 'hidden'
  }
  //console.log(`wrapperWidth: ${wrapperWidth} -- screenSize.width: ${screenSize.width}`)
  return {width: wrapperWidth, style: wrapperStyle}
}

export default usePageWrapper;



